import React, { useState } from 'react';

const ComingSoon = ({ onUnlock }) => {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [secretCode, setSecretCode] = useState('');
  const [showSecretInput, setShowSecretInput] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      // You can integrate with backend later to save emails
      setIsSubscribed(true);
      setEmail('');
    }
  };

  const handleSecretSubmit = (e) => {
    e.preventDefault();
    // Secret code to access the full site - change this to your preferred code
    if (secretCode === 'silk2025') {
      localStorage.setItem('silk_dev_access', 'true');
      onUnlock();
    }
  };

  return (
    <div style={styles.container}>
      {/* Background Pattern */}
      <div style={styles.bgPattern}></div>
      
      {/* Content */}
      <div style={styles.content}>
        {/* Logo/Brand */}
        <div style={styles.brandSection}>
          <div style={styles.ornamentTop}>
            <span style={styles.ornamentLine}></span>
            <span style={styles.ornamentDiamond}></span>
            <span style={styles.ornamentLine}></span>
          </div>
          
          <img 
            src="/logo.png" 
            alt="Silk & Sentiment - Elegance in every thread"
            style={styles.logoImage}
          />
          
          <div style={styles.divider}></div>
        </div>

        {/* Coming Soon Message */}
        <div style={styles.messageSection}>
          <p style={styles.comingText}>Launching Soon</p>
          <h2 style={styles.headline}>
            Something Beautiful<br />is Being Crafted
          </h2>
          <p style={styles.description}>
            We're weaving together centuries of heritage and artistry to bring you 
            an extraordinary collection of bespoke Indian couture. 
            Handcrafted in Lucknow, curated for the world.
          </p>
        </div>

        {/* Email Signup */}
        <div style={styles.signupSection}>
          {!isSubscribed ? (
            <>
              <p style={styles.signupText}>Be the first to experience our collection</p>
              <form onSubmit={handleSubscribe} style={styles.form}>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  style={styles.input}
                  required
                />
                <button type="submit" style={styles.button}>
                  Notify Me
                </button>
              </form>
            </>
          ) : (
            <div style={styles.thankYou}>
              <p style={styles.thankYouText}>✓ Thank you! We'll notify you when we launch.</p>
            </div>
          )}
        </div>

        {/* Contact Info */}
        <div style={styles.contactSection}>
          <p style={styles.contactText}>
            For inquiries: <a href="mailto:info@silkandsentiment.com" style={styles.link}>info@silkandsentiment.com</a>
          </p>
          <p style={styles.contactText}>
            WhatsApp: <a href="https://wa.me/919151060995" style={styles.link}>+91 9151 060 995</a>
          </p>
        </div>

        {/* Footer */}
        <div style={styles.footer}>
          <p style={styles.footerText}>Crafted in Lucknow · Curated for the World</p>
          <p style={styles.copyright}>© 2025 Silk &amp; Sentiment. All rights reserved.</p>
        </div>

        {/* Secret Developer Access - Hidden */}
        <div 
          style={styles.devAccess}
          onClick={() => setShowSecretInput(!showSecretInput)}
        >
          {showSecretInput && (
            <form onSubmit={handleSecretSubmit} style={styles.secretForm}>
              <input
                type="password"
                value={secretCode}
                onChange={(e) => setSecretCode(e.target.value)}
                placeholder="Developer access code"
                style={styles.secretInput}
              />
              <button type="submit" style={styles.secretButton}>→</button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(180deg, #fffef2 0%, #f6f5e8 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    overflow: 'hidden',
    padding: '40px 24px',
  },
  bgPattern: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundImage: `
      radial-gradient(ellipse at 20% 30%, rgba(201, 169, 97, 0.08) 0%, transparent 50%),
      radial-gradient(ellipse at 80% 70%, rgba(201, 169, 97, 0.08) 0%, transparent 50%)
    `,
    pointerEvents: 'none',
  },
  content: {
    maxWidth: '600px',
    width: '100%',
    textAlign: 'center',
    position: 'relative',
    zIndex: 1,
  },
  brandSection: {
    marginBottom: '48px',
  },
  ornamentTop: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '32px',
  },
  ornamentLine: {
    width: '60px',
    height: '1px',
    background: 'linear-gradient(90deg, transparent, rgba(201, 169, 97, 0.6), transparent)',
  },
  ornamentDiamond: {
    width: '8px',
    height: '8px',
    background: '#c9a961',
    transform: 'rotate(45deg)',
    margin: '0 16px',
  },
  logoImage: {
    maxWidth: '420px',
    width: '100%',
    height: 'auto',
    margin: '0 auto',
    display: 'block',
  },
  divider: {
    width: '80px',
    height: '1px',
    background: 'linear-gradient(90deg, transparent, #c9a961, transparent)',
    margin: '32px auto 0',
  },
  messageSection: {
    marginBottom: '48px',
  },
  comingText: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 'clamp(28px, 5vw, 42px)',
    fontWeight: '400',
    color: '#c9a961',
    marginBottom: '24px',
    letterSpacing: '0.1em',
  },
  headline: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 'clamp(24px, 4vw, 36px)',
    fontWeight: '400',
    color: '#333333',
    lineHeight: '1.3',
    marginBottom: '24px',
  },
  description: {
    fontFamily: "'Inter', sans-serif",
    fontSize: '15px',
    lineHeight: '1.8',
    color: '#666666',
    maxWidth: '480px',
    margin: '0 auto',
  },
  signupSection: {
    marginBottom: '48px',
  },
  signupText: {
    fontFamily: "'Inter', sans-serif",
    fontSize: '13px',
    color: '#666666',
    marginBottom: '20px',
  },
  form: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  input: {
    flex: '1',
    minWidth: '220px',
    maxWidth: '300px',
    padding: '16px 20px',
    border: '1px solid #bcbbb4',
    background: '#ffffff',
    fontFamily: "'Inter', sans-serif",
    fontSize: '14px',
    color: '#333333',
    outline: 'none',
    transition: 'border-color 0.3s ease',
  },
  button: {
    padding: '16px 32px',
    background: '#333333',
    color: '#fffef2',
    border: 'none',
    fontFamily: "'Inter', sans-serif",
    fontSize: '11px',
    fontWeight: '500',
    letterSpacing: '0.15em',
    textTransform: 'uppercase',
    cursor: 'pointer',
    transition: 'background 0.3s ease',
  },
  thankYou: {
    padding: '20px',
    background: 'rgba(201, 169, 97, 0.1)',
    border: '1px solid rgba(201, 169, 97, 0.3)',
  },
  thankYouText: {
    fontFamily: "'Inter', sans-serif",
    fontSize: '14px',
    color: '#c9a961',
  },
  contactSection: {
    marginBottom: '48px',
  },
  contactText: {
    fontFamily: "'Inter', sans-serif",
    fontSize: '13px',
    color: '#666666',
    marginBottom: '8px',
  },
  link: {
    color: '#c9a961',
    textDecoration: 'none',
    transition: 'color 0.3s ease',
  },
  footer: {
    paddingTop: '32px',
    borderTop: '1px solid rgba(188, 187, 180, 0.5)',
  },
  footerText: {
    fontFamily: "'Inter', sans-serif",
    fontSize: '12px',
    color: '#666666',
    fontStyle: 'italic',
    marginBottom: '8px',
  },
  copyright: {
    fontFamily: "'Inter', sans-serif",
    fontSize: '11px',
    color: '#bcbbb4',
  },
  devAccess: {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    width: '40px',
    height: '40px',
    cursor: 'pointer',
    zIndex: 100,
  },
  secretForm: {
    position: 'absolute',
    bottom: '50px',
    right: '0',
    display: 'flex',
    gap: '8px',
    background: '#ffffff',
    padding: '8px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
  },
  secretInput: {
    width: '160px',
    padding: '8px 12px',
    border: '1px solid #bcbbb4',
    fontFamily: "'Inter', sans-serif",
    fontSize: '12px',
    outline: 'none',
  },
  secretButton: {
    padding: '8px 16px',
    background: '#333333',
    color: '#ffffff',
    border: 'none',
    cursor: 'pointer',
  },
};

export default ComingSoon;
